/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 *
 * This  software  has  been  provided pursuant  to  a  License
 * Agreement  containing  restrictions on  its  use.   The  software
 * contains  valuable  trade secrets and proprietary information  of
 * Pegasystems Inc and is protected by  federal   copyright law.  It
 * may  not be copied,  modified,  translated or distributed in  any
 * form or medium,  disclosed to third parties or used in any manner
 * not provided for in  said  License Agreement except with  written
 * authorization from Pegasystems Inc.
 */

import BufferedDataQueue from './buffered-data-queue';

class BufferedDataView<T> {
  private bufferedDataQueues: { [dataSource: string]: BufferedDataQueue<T> };

  constructor() {
    this.bufferedDataQueues = {};
  }

  getBufferedDataQueueForDataPage(dataSource: string) {
    return this.bufferedDataQueues[dataSource];
  }

  addBufferedDataQueueForDataPage(
    dataSource: string,
    finalDataViewCall: (arg: T) => Promise<unknown>,
    combiner: (dataViewCallA: T, dataViewCallB: T) => void,
    separator: (
      combinedDataViewCall: T & {
        dataViewCallMap: {
          [identifier: string]: { promise: Promise<unknown>; resolve: (value: unknown) => void };
        };
      },
      data: unknown
    ) => void,
    comparator: (dataViewCallA: T, dataViewCallB: T) => boolean,
    maxtime?: number,
    maxsize?: number
  ) {
    if (!this.getBufferedDataQueueForDataPage(dataSource)) {
      this.bufferedDataQueues[dataSource] = new BufferedDataQueue<T>(
        finalDataViewCall,
        combiner,
        comparator,
        separator,
        maxtime,
        maxsize
      );
    }
    return this.bufferedDataQueues[dataSource];
  }
}

export default BufferedDataView;
